// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1152":"e86c1b26","2870":"2e75716e","5973":"d0467be4","8384":"fe8e102f"}[chunkId] + ".chunk.css";
};